import http from "@/utils/http";
//保存电话公开设置
export const saveUserSetting = data => http.get('api/saveUserSetting.htm', {data})
//保存个人信息
export const setupUserInfo = userAttribute => http.post('user/setupUserInfo.htm', {userAttribute: JSON.stringify(userAttribute)})